import React from "react";

const features = [
  {
    icon: "icon-27",
    title: "24/7 Operations Support",
    text: "Day or night, we’re here for you. Get help anytime with our dependable 24/7 customer and vehicle support.",
  },
  {
    icon: "icon-49",
    title: "Clean & Comfortable Rides",
    text: "Travel in style with well-sanitized, air-conditioned cabs and experienced drivers focused on your comfort.",
  },
];

const WhyChooseUsSection = () => {
  return (
    <section className="why-chooseus-section py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column — Title and Description */}
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="section-title mb_60">
              <span className="sub-title">WHY Pune Corporate Cars India Private Limited?</span>
              <h2 className="title">
                Reliable, Comfortable, And Always On Time – Travel With
                Confidence
              </h2>
              <p className="why-chooseus-description">
                Pune Corporate Cars India Private Limited is your go-to partner for safe, punctual, and
                affordable travel across Maharashtra. Trusted by thousands for
                city rides, outstation trips, and airport transfers.
              </p>
            </div>
          </div>

          {/* Right Column — Feature Boxes */}
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="row">
              {features.map((item, index) => (
                <div
                  className="col-md-6 col-sm-12 mb-4"
                  key={index}
                >
                  <div className="why-chooseus-block yellow-bg">
                    <div className="why-chooseus-icon">
                      <i className={item.icon}></i>
                    </div>
                    <h5 className="why-chooseus-title ora-color">{item.title}</h5>
                    <p className="why-chooseus-text text-white">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
